export const EMPTY_OBJECT = {};

export function isEmpty(object: {}) {
    return Object.keys(object).length === 0;
}
